export const ACTION_SET_MAP = 'ACTION_SET_MAP';
